import {readable} from "svelte/store";

export type Now = {
    ts: number,
}

/**
 * Текущее время/дата
 */
export const now = readable<Now>(getNow(), set => {
    const autoUpdateInterval = setInterval(() => {
        set(getNow());
    }, 1000);

    return () => {
        !!autoUpdateInterval && clearInterval(autoUpdateInterval);
    }
});

function getNow(): Now {
    return {
        ts: Date.now()
    }
}